import { Table, Tbody, Tr, Text, Td } from "@chakra-ui/react"
import { Ellipsis } from "brokertslib/src/components"
import { AcquisitionNumber } from "BrokerTsLib/src/dtos/Shared"

export const AcquisitionNumbersTable = ({ rows }: { rows: Array<AcquisitionNumber> }) => {
    return (
        <Table variant="unstyled">
            <Tbody>
                {rows &&
                    rows.sort((a, b) => a.insurerName.localeCompare(b.insurerName)).map((row, index) => {
                        return (
                            <Tr key={index}>
                                <Td py={.5} sx={{ maxW: '300px' }}>
                                    <Ellipsis>{row.insurerName}</Ellipsis>
                                </Td>
                                <Td py={.5}>
                                    <Text>{row.acquisitionNumber}</Text>
                                </Td>
                            </Tr>
                        )
                    })}
            </Tbody>
        </Table>
    )
}
